import { IAppConfiguration } from '../cemexng2components/components/app-configuration';

export default [
  {
    feature: 'sales-offices.lien-release',
    country: ['US'],
    role_any: ['ARMORGLIEN']
  }
] as IAppConfiguration[];
